import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72d18b6d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 登记入库 ", -1))
const _hoisted_2 = { class: "d-flex mt-20" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1))
const _hoisted_5 = { class: "d-flex mt-20" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1))
const _hoisted_8 = { class: "d-flex mt-20" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1))
const _hoisted_11 = { class: "d-flex mt-20" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1))
const _hoisted_14 = { class: "d-flex mt-20" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_16 = { class: "w-75 mt-20" }
const _hoisted_17 = { class: "d-flex" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1))
const _hoisted_19 = { class: "d-flex" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, null, -1))
const _hoisted_22 = { class: "w-75 mt-20" }
const _hoisted_23 = { class: "d-flex" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1))
const _hoisted_25 = { class: "d-flex" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1))
const _hoisted_27 = { class: "mt-20" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("添加")
const _hoisted_29 = { class: "d-flex justify-content--center" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_31 = { class: "dialog-footer" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_33 = /*#__PURE__*/_createTextVNode("确 定 ")

import {computed, getCurrentInstance, reactive, ref, watch} from "vue";
import {
  action_rk,
  canSelectFixedAssetStatus, depreciationMethods,
  fixed_asset_status_idle,
  fixed_asset_status_using,
  unitArr,
    office_asset_currency_list
} from './OfficeAssetUtils'
import IevDialog from "@/views/ViewsComponents/officeAssets/IevDialog.vue";
import FixedAssetListDialog from "@/views/ViewsComponents/officeAssets/FixedAssetListDialog.vue";



export default /*#__PURE__*/_defineComponent({
  props: {
    orgList: null,
    companyList: null,
    categoryList: null,
    usersListApi: null,
    registerApi: null,
    show: null,
    callback: null
  },
  setup(__props: any) {

const props = __props as {
  orgList: any[],
  companyList: any[],
  categoryList: any[],
  usersListApi: (param: any) => Promise<any>,
  registerApi: (param: any) => Promise<any>,
  show: Boolean,
  callback: (obj: { command: string, data: any }) => any
}



// const emit = defineEmits(["register"])
const extraActiveItem = ref("LY")
const registerDialogInfo = reactive({
  isShow: false,
  loading: false,
  selectedIev: null
})
const registerFormRef = ref()
watch(() => props.show, (curr, old) => {
  if (curr) {
    clearRegisterForm()
    queryUser('')
    registerForm.count = 1
    registerDialogInfo.isShow = true
    setTimeout(() => {
      registerFormRef.value.clearValidate()
    }, 50)
  }
})
const userInfo = reactive({
  userList: [],
  loading: false,
  key: null
})
const queryUser = (key?: string) => {
  if (key == userInfo.key) {
    return
  }
  userInfo.loading = true
  props.usersListApi({page: 1, size: 100, query: key}).then((r: any) => {
    userInfo.loading = false
    userInfo.userList = r.data.map((i: any) => {
      return {
        userId: i.userId,
        label: i.realName + "(" + i.alias + ")"
      }
    })
  }).catch((e: any) => {
    userInfo.loading = false
  })
}
const checkCount = (rule: any, value: any, cb: any) => {
  if (!value) {
    cb("请输入数量")
  } else {
    if (parseInt(value) < 1) {
      cb("数量最小为1")
    } else {
      cb()
    }
  }
}
const checkOwner = (rule: any, value: any, cb: any) => {
  if (!!value) {
    //有领用人
    if (registerForm.status == fixed_asset_status_idle) {
      cb("闲置时不能实则领用人")
    } else if (!registerForm.start) {
      cb("请设置领用日期")
    } else {
      cb()
    }
  } else {
    if (registerForm.status == fixed_asset_status_using) {
      cb("使用中时必须设置领用人")
    } else if (!!registerForm.start) {
      cb("请清空领用日期")
    } else {
      cb()
    }
  }
}

const registerForm = reactive<{
  orgId?: number | null,
  companyId?: number | null,
  name?: string | null,
  categoryNo?: string | null,
  status?: string | null,
  managerId?: number | null,
  inputNo?: string | null,
  count?: number | null,
  ownerId?: number | null,
  start?: string | null,
  spec?: string | null,
  deviceId?: string | null,
  unit?: string | null,
  place?: string | null,
  note?: string | null,
  purchasingUserId?: string | null,
  purchasingCurrency?:string|null,
  purchasingPrice?: number | null,
  purchasingInvoiceId?: number | null,
  purchasingDate?: string | null,
  bindAssets: any[],
  initCount?: null | number,
}>(
    {
      orgId: null,
      companyId: null,
      name: null,
      categoryNo: null,
      status: null,
      managerId: null,
      inputNo: null,
      count: null,
      ownerId: null,
      start: null,
      spec: null,
      deviceId: null,
      unit: null,
      place: null,
      note: null,
      purchasingUserId: null,
      purchasingPrice: null,
      purchasingInvoiceId: null,
      purchasingDate: null,
      bindAssets: [],
      initCount: null,
      purchasingCurrency:"CNY"
    })
const ievDialogInfo = reactive({
  isShow: false,
})
const showIevDialog = () => {
  ievDialogInfo.isShow = false
  setTimeout(() => {
    ievDialogInfo.isShow = true
  }, 50)
}
const deleteIev = () => {
  registerDialogInfo.selectedIev = null
}
const bindIev = (row: any) => {
  registerDialogInfo.selectedIev = row
  registerForm.purchasingPrice = row.totalAmount
  ievDialogInfo.isShow = false
}
const hasBindIev = computed(() => {
  return !!registerDialogInfo.selectedIev
})
const getRealRegisterObj = () => {
  return {
    orgId: registerForm.orgId,
    companyId: registerForm.companyId,
    name: registerForm.name,
    categoryNo: registerForm.categoryNo,
    status: registerForm.status,
    managerId: registerForm.managerId,
    inputNo: registerForm.inputNo,
    count: registerForm.count,
    ownerId: registerForm.ownerId,
    start: registerForm.start,
    extra: {
      spec: registerForm.spec,
      deviceId: registerForm.deviceId,
      unit: registerForm.unit,
      place: registerForm.place,
      note: registerForm.note,
      initCount: registerForm.initCount,
      purchasingInfo: {
        userId: registerForm.purchasingUserId,
        price: registerForm.purchasingPrice,
        date: registerForm.purchasingDate,
        invoiceId: registerForm.purchasingInvoiceId,
        currency:registerForm.purchasingCurrency
      },
      bindAssets: registerForm.bindAssets
    },
  }
}
const clearRegisterForm = () => {
  registerForm.orgId = null;
  registerForm.companyId = null;
  registerForm.name = null;
  registerForm.categoryNo = null;
  registerForm.status = null;
  registerForm.managerId = null;
  registerForm.inputNo = null;
  registerForm.count = null;
  registerForm.ownerId = null;
  registerForm.start = null;
  registerForm.spec = null;
  registerForm.deviceId = null;
  registerForm.unit = null;
  registerForm.place = null;
  registerForm.note = null;
  registerForm.purchasingUserId = null;
  registerForm.purchasingPrice = null;
  registerForm.purchasingInvoiceId = null;
  registerForm.purchasingDate = null;
  registerForm.bindAssets = [];
  registerForm.initCount = null;
  fixedAssetListDialogInfo.selectedList = []
}

const countCantInput = computed<boolean>(() => {
  return !!registerForm.deviceId || !!registerForm.inputNo || registerForm.bindAssets.length > 0 || registerForm.status == fixed_asset_status_using
})
watch(() => countCantInput, (n, o) => {
  if (n) {
    registerForm.count = 1
  }
})
// watch(() => registerForm.deviceId, (cur, old) => {
//   if (!!cur) {
//     registerForm.count = 1
//   }
// })
// watch(() => registerForm.inputNo, (cur, old) => {
//   if (!!cur) {
//     registerForm.count = 1
//   }
// })
// watch(() => registerForm.bindAssets, (cur, old) => {
//   if (cur.length > 0) {
//     registerForm.count = 1
//   }
// })
watch(() => registerForm.start, (cur, old) => {
  registerFormRef.value.validateField("ownerId", null)
})


const fixedAssetListDialogInfo = reactive<{
  isShow: Boolean,
  selectedList: any[]
}>({
  isShow: false,
  selectedList: []
})
const showFixedAssetListDialog = () => {
  fixedAssetListDialogInfo.isShow = false
  setTimeout(() => {
    fixedAssetListDialogInfo.isShow = true
  })
}
const onAssetSelected = (list: any[]) => {
  let temp = fixedAssetListDialogInfo.selectedList
  for (let i = 0; i < list.length; i++) {
    if (temp.filter(item => item.id == list[i].id).length < 1) {
      temp.push(list[i])
    }
  }
  fixedAssetListDialogInfo.selectedList = temp
  registerForm.bindAssets = temp.map(item => item.id)
}
const deleteBindAsset = (asset: any) => {
  fixedAssetListDialogInfo.selectedList = fixedAssetListDialogInfo.selectedList.filter(i => i.id != asset.id)
}

let instance: any = getCurrentInstance()
const globalProperties = instance.appContext.config.globalProperties
const registerAsset = () => {
  registerFormRef.value.validate((valid: boolean) => {
    if (valid) {
      if (registerDialogInfo.loading) return false;
      registerDialogInfo.loading = true
      props.registerApi(getRealRegisterObj()).then((r: any) => {
        registerDialogInfo.loading = false
        registerDialogInfo.isShow = false
        globalProperties.$message.success("登记入库成功")
        props.callback({command: action_rk, data: null})
      }).catch((e: any) => {
        globalProperties.$message.error("登记入库失败：" + e)
        registerDialogInfo.loading = false
      })
    } else {
      return false;
    }
  })
}


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      class: "registerFixedDialog",
      modelValue: _unref(registerDialogInfo).isShow,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(registerDialogInfo).isShow) = $event)),
      draggable: "",
      width: "960px"
    }, {
      header: _withCtx(() => [
        _hoisted_1
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_31, [
          _createVNode(_component_el_button, {
            onClick: _cache[20] || (_cache[20] = ($event: any) => (_unref(registerDialogInfo).isShow=false))
          }, {
            default: _withCtx(() => [
              _hoisted_32
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: registerAsset,
            loading: _unref(registerDialogInfo).loading,
            disabled: _unref(registerDialogInfo).loading
          }, {
            default: _withCtx(() => [
              _hoisted_33
            ]),
            _: 1
          }, 8, ["loading", "disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          class: "registerForm",
          ref_key: "registerFormRef",
          ref: registerFormRef,
          model: _unref(registerForm)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_el_form_item, {
                  label: "所属团队",
                  prop: "orgId",
                  class: "flex-1",
                  required: "",
                  rules: [{required:true,message:'请选择所属团队'}]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(registerForm).orgId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(registerForm).orgId) = $event)),
                      placeholder: "所属团队"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.orgList, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _hoisted_3,
                _createVNode(_component_el_form_item, {
                  label: "所属公司",
                  prop: "companyId",
                  class: "flex-1",
                  required: "",
                  rules: [{required:true,message:'请选择所属公司'}]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(registerForm).companyId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(registerForm).companyId) = $event)),
                      placeholder: "所属公司"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.companyList, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _hoisted_4,
                _createVNode(_component_el_form_item, {
                  label: "旧编码",
                  prop: "inputNo",
                  class: "flex-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(registerForm).inputNo,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(registerForm).inputNo) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_el_form_item, {
                  label: "资产名称",
                  prop: "name",
                  class: "flex-1",
                  required: "",
                  rules: [{required:true,message:'请输入资产名称'}]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(registerForm).name,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(registerForm).name) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _hoisted_6,
                _createVNode(_component_el_form_item, {
                  label: "规格型号",
                  prop: "spec",
                  class: "flex-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(registerForm).spec,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(registerForm).spec) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _hoisted_7,
                _createVNode(_component_el_form_item, {
                  label: "电脑设备ID",
                  prop: "deviceId",
                  class: "flex-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(registerForm).deviceId,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(registerForm).deviceId) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_el_form_item, {
                  label: "资产类别",
                  prop: "categoryNo",
                  class: "flex-1",
                  required: "",
                  rules: [{required:true,message:'请选择资产类别'}]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(registerForm).categoryNo,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(registerForm).categoryNo) = $event)),
                      placeholder: "资产类别"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.categoryList, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.name,
                            value: item.no
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _hoisted_9,
                _createVNode(_component_el_form_item, {
                  label: "单位",
                  prop: "unit",
                  class: "flex-1",
                  required: "",
                  rules: [{required:true,message:'请输入单位'}]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(registerForm).unit,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(registerForm).unit) = $event)),
                      placeholder: "单位"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(unitArr), (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _hoisted_10,
                _createVNode(_component_el_form_item, {
                  label: "数量",
                  prop: "count",
                  class: "flex-1",
                  rules: [{required:true,message:'请输入数量'},{ validator: checkCount, trigger: 'blur',message: '数量最小为1' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(registerForm).count,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(registerForm).count) = $event)),
                      disabled: _unref(countCantInput),
                      oninput: "value=value.replace(/[^\\d]/g,'')"
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }, 8, ["rules"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_el_form_item, {
                  label: "使用状态",
                  prop: "status",
                  class: "flex-1",
                  required: "",
                  rules: [{required:true,message:'请选择使用状态'},]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(registerForm).status,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(registerForm).status) = $event)),
                      placeholder: "使用状态"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(canSelectFixedAssetStatus), (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _hoisted_12,
                _createVNode(_component_el_form_item, {
                  label: "存放位置",
                  prop: "place",
                  class: "flex-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(registerForm).place,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(registerForm).place) = $event)),
                      placeholder: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _hoisted_13,
                _createVNode(_component_el_form_item, {
                  prop: "managerId",
                  label: "管理员",
                  class: "flex-1",
                  required: "",
                  rules: [{required:true,message:'请选择管理员'}]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(registerForm).managerId,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(registerForm).managerId) = $event)),
                      placeholder: "请输入关键字",
                      remote: "",
                      filterable: "",
                      clearable: "",
                      "remote-method": queryUser,
                      loading: _unref(userInfo).loading,
                      autocomplete: "off"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userInfo).userList, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.userId,
                            label: item.label,
                            value: item.userId
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "loading"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_el_form_item, {
                  label: "备注",
                  prop: "note",
                  class: "flex-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(registerForm).note,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(registerForm).note) = $event)),
                      type: "textarea",
                      autosize: { minRows: 3},
                      placeholder: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _hoisted_15,
              _createVNode(_component_el_tabs, {
                modelValue: extraActiveItem.value,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((extraActiveItem).value = $event)),
                class: "mt-20",
                type: "card"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_tab_pane, {
                    label: "领用信息",
                    name: "LY"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_el_form_item, {
                            label: "资产变动单号",
                            class: "flex-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                placeholder: "",
                                disabled: ""
                              })
                            ]),
                            _: 1
                          }),
                          _hoisted_18,
                          _createVNode(_component_el_form_item, {
                            label: "领用日期",
                            prop: "start",
                            class: "flex-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                modelValue: _unref(registerForm).start,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(registerForm).start) = $event)),
                                type: "date",
                                "value-format": "YYYY-MM-DD",
                                placeholder: "领用日期"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(_component_el_form_item, {
                            prop: "ownerId",
                            label: "领用人",
                            rules: [{validator:checkOwner,trigger: 'change'}]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _unref(registerForm).ownerId,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(registerForm).ownerId) = $event)),
                                placeholder: "请输入关键字",
                                remote: "",
                                filterable: "",
                                clearable: "",
                                "remote-method": queryUser,
                                loading: _unref(userInfo).loading,
                                autocomplete: "off"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userInfo).userList, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.userId,
                                      label: item.label,
                                      value: item.userId
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "loading"])
                            ]),
                            _: 1
                          }, 8, ["rules"]),
                          _hoisted_20,
                          _hoisted_21
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_tab_pane, {
                    label: "采购信息",
                    name: "CG"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createVNode(_component_el_form_item, {
                            prop: "purchasingUserId",
                            label: "采购人",
                            required: "",
                            "label-width": "80px",
                            rules: [{required:true,message:'请选择采购人'}]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _unref(registerForm).purchasingUserId,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(registerForm).purchasingUserId) = $event)),
                                placeholder: "请输入关键字",
                                remote: "",
                                filterable: "",
                                clearable: "",
                                "remote-method": queryUser,
                                loading: _unref(userInfo).loading,
                                autocomplete: "off"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userInfo).userList, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.userId,
                                      label: item.label,
                                      value: item.userId
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "loading"])
                            ]),
                            _: 1
                          }),
                          _hoisted_24,
                          _createVNode(_component_el_form_item, {
                            prop: "purchasingCurrency",
                            label: "币种",
                            required: "",
                            rules: [{required:true,message:'请选择币种'}]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _unref(registerForm).purchasingCurrency,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(registerForm).purchasingCurrency) = $event)),
                                placeholder: "请选择币种"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(office_asset_currency_list), (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.value,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", null, [
                            _createVNode(_component_el_form_item, {
                              label: "采购单价",
                              prop: "purchasingPrice",
                              class: "flex-1",
                              "label-width": "80px",
                              rules: [{required:true,message:'请输入采购单价'}],
                              required: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _unref(registerForm).purchasingPrice,
                                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(registerForm).purchasingPrice) = $event)),
                                  class: "price-input",
                                  disabled: _unref(hasBindIev),
                                  oninput: "value=value.replace(/[^\\d]/g,'')"
                                }, null, 8, ["modelValue", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _hoisted_26,
                          _createVNode(_component_el_form_item, {
                            label: "采购日期",
                            prop: "purchasingDate",
                            class: "flex-1",
                            required: "",
                            rules: [{required:true,message:'请选择采购日期'}]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                modelValue: _unref(registerForm).purchasingDate,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(registerForm).purchasingDate) = $event)),
                                type: "date",
                                "value-format": "YYYY-MM-DD",
                                placeholder: "采购日期"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_tab_pane, {
                    label: "捆绑资产",
                    name: "KB"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: showFixedAssetListDialog
                        }, {
                          default: _withCtx(() => [
                            _hoisted_28
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table, {
                          border: "",
                          class: "mt-10",
                          data: _unref(fixedAssetListDialogInfo).selectedList,
                          "row-key": "id",
                          "max-height": "200px"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_table_column, {
                              label: "序号",
                              type: "index",
                              width: "70"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "所属团队",
                              prop: "orgName",
                              width: "100"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "所属公司",
                              prop: "companyName",
                              width: "180"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "资产编号",
                              prop: "no",
                              width: "200"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "资产名称",
                              prop: "name",
                              width: "120"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "规格型号",
                              prop: "spec",
                              width: "100"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "电脑设备ID",
                              prop: "deviceId",
                              width: "120"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "资产类别",
                              prop: "categoryName",
                              width: "100"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "单位",
                              prop: "unit",
                              width: "60"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "数量",
                              prop: "count",
                              width: "60"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "使用状态",
                              prop: "statusDesc",
                              width: "100"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "操作",
                              fixed: "right",
                              width: "80"
                            }, {
                              default: _withCtx(({ row }) => [
                                _createElementVNode("div", _hoisted_29, [
                                  _createVNode(_component_el_space, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_link, {
                                        type: "danger",
                                        onClick: ($event: any) => (deleteBindAsset(row))
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_30
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["data"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(IevDialog, {
      show: _unref(ievDialogInfo).isShow
    }, null, 8, ["show"]),
    _createVNode(FixedAssetListDialog, {
      show: _unref(fixedAssetListDialogInfo).isShow,
      "category-list": __props.categoryList,
      "company-list": __props.companyList,
      "org-list": __props.orgList,
      "filter-bind": true,
      status: null,
      onSelect: onAssetSelected
    }, null, 8, ["show", "category-list", "company-list", "org-list"])
  ]))
}
}

})